import { render, staticRenderFns } from "./DeletedAccessGroups.vue?vue&type=template&id=0dc5b537"
import script from "./DeletedAccessGroups.vue?vue&type=script&lang=js"
export * from "./DeletedAccessGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc5b537')) {
      api.createRecord('0dc5b537', component.options)
    } else {
      api.reload('0dc5b537', component.options)
    }
    module.hot.accept("./DeletedAccessGroups.vue?vue&type=template&id=0dc5b537", function () {
      api.rerender('0dc5b537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Endpoints/DeletedAccessGroups.vue"
export default component.exports